import React from 'react';
import DropdownMenu from './DropdownMenu';
import DropdownMenuItem from './ReportDropdown';
import utils from '../../lib/utils';

const available_options = [
  {
    label: 'Report an issue',
    value: 'Report',
    className: 'report_issue_block',
    iconclassName: 'flag',
  },
  {
    label: 'Custom Tags',
    value: 'Tags',
    className: 'report_issue_block',
    iconclassName: 'sell',
  },
  {
    label: 'Block a number',
    value: 'Block',
    className: 'report_issue_block',
    iconclassName: 'remove_circle',
  },
  {
    label: 'Opted out numbers',
    value: 'Optout',
    className: 'report_issue_block',
    iconclassName: 'chat',
  },
];

const filterList = (allowedOptions, blockKnownNumber, isBlocked) => {
  const businessStatus = utils.getCookie('subscription_status');
  const features = utils.getCookie('features');
  let options = available_options
    .filter((option) => allowedOptions.includes(option.value))
    .map((option) => {
      if (blockKnownNumber && option.value === 'Block') {
        return { ...option, label: `${isBlocked ? 'Unblock' : 'Block'} this number` };
      }
      return option;
    });
  if (features.includes('REPORT_CONVERSATION_HIDDEN')) {
    const filteredOptions = options.filter((option) => option.value !== 'Report');
    return filteredOptions;
  } else if (businessStatus === 'LIVE') {
    return options;
  } else {
    const filterdOptions = options.filter((option) => option.value !== 'Optout');
    return filterdOptions;
  }
};
const StatusSelectDropdown = ({ onChange, selectedOption, allowedOptions, isBlocked, blockKnownNumber, ...rest }) => {
  return (
    <DropdownMenu {...rest}>
      {/* eslint react/no-array-index-key: "off" */
        filterList(allowedOptions, blockKnownNumber, isBlocked).map((item, index) => {
          return (
            <DropdownMenuItem
              label={item.label}
              key={index}
              value={item.value}
              onClick={onChange}
              type="BUTTON"
              className={item.className}
              iconclassName={item.iconclassName}
            />
          );
        })}
    </DropdownMenu>
  );
};

export default StatusSelectDropdown;
